var _path, _path2, _path3, _path4, _mask, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAF8F2",
  d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCE7B1",
  d: "M63.583 41.834v33.417H82c-1.945-2.112-5.717-8.784-5.25-18.584-.39-4.194-3.567-13.033-13.167-14.833Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeWidth: 1.667,
  d: "M43.306 56.611c.302 9.709-3.53 16.512-5.483 18.7-2.367 1.283-2.979 3.646-2.988 4.667-.093 4.27 3.443 5.572 5.222 5.689h40.386c3.046-1.021 4.468-2.422 4.555-5.689.07-2.614-1.886-4.2-2.872-4.667-4.828-5.228-5.552-14.645-5.31-18.7-.551-5.007-4.7-15.04-16.885-15.11-12.185-.07-16.16 10.044-16.624 15.11Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeWidth: 1.667,
  d: "M38.166 75.167h13.5M56.833 75.167h24.834"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "bell_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68.666 85.25c0 1.15-.224 2.287-.66 3.349a8.755 8.755 0 0 1-1.878 2.838 8.66 8.66 0 0 1-2.812 1.897 8.594 8.594 0 0 1-6.633 0 8.661 8.661 0 0 1-2.812-1.897 8.756 8.756 0 0 1-1.878-2.838 8.824 8.824 0 0 1-.66-3.349h17.333Z"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCE7B1",
  stroke: "#36485C",
  strokeWidth: 3.333,
  d: "M68.666 85.25c0 1.15-.224 2.287-.66 3.349a8.755 8.755 0 0 1-1.878 2.838 8.66 8.66 0 0 1-2.812 1.897 8.594 8.594 0 0 1-6.633 0 8.661 8.661 0 0 1-2.812-1.897 8.756 8.756 0 0 1-1.878-2.838 8.824 8.824 0 0 1-.66-3.349h17.333Z",
  mask: "url(#bell_svg__a)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeWidth: 1.667,
  d: "M56.155 42c-.428-1.974-.227-5.972 3.996-6.166 1.77.132 4.941 1.55 3.471 6.167"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeWidth: 1.667,
  d: "M76.903 29.084c5.012.994 14.825 6.037 13.978 18.262M43.152 29.084c-5.012.994-14.825 6.037-13.979 18.262M75.667 35.398c3.218.886 9.553 4.689 9.152 12.808M44.39 35.398c-3.219.886-9.554 4.689-9.153 12.808"
})));
export default SvgBell;